import { createApp, reactive, ref, readonly } from "vue";
import { i18n } from "../i18n";
import AutoModal from "../vue/AutoModal.vue";
import SummaryDateNavView from "../view/components/summaryDateNav/SummaryDateNavView.vue";
import AutoAIModal from "../view/components/autoAI/AutoAIModal.vue";
import { MODAL_ID } from "./enums/modal_types";
import { goDateString, dateFromSecondsTimestamp, createStartAndEndDatesFromArray, roundTwoDecimals, timestampSecsFromDate, isQueryParamTrue, addDaysToDate } from './common';
import { getSlotToDateString } from './slot_helpers';
import { toOplusTime, dateFromString } from "../common/common";
import { transformCompany, transformUser } from "./transformers";
import { slotPostRequest, slotPutRequest, slotDeleteRequest, getPageSlotURL } from "./slot_crud_requests"
import { DELETE_SLOT_PARAM_STR, SLOT_SUBMIT_BUTTON_ID, handleCreateSuccess, handleUpdateSuccess, handleDeleteSuccess, handleTemplateCreateSuccess, DELETE_REPEAT_INPUT_VALUE } from "./slot_crud_common"
import { ACTIONS_TYPE, undoActionRequest, addToUndoStack, getLastUndoStack, removeDeletedSlotInStack, disableUndoLoading, removeLastActionFromUndoStack, enableUndoLoading, disableSaveUndo } from "./slot_undo";

import periodTypes from "../table/v1/periodTypes";

import { initPlanFunctions, makeComputedValuesMap, newBranchStore, newBranchFromRaw, newMeStore, newRoleStoreFromRaw, calcTableStartDate, calcViewType, calcTableEndDate, getDateStringsForSlot, computeRequestedVacationByUser, computeMonthlyLaborFlags, computeLaborFlags } from "../employmentShiftTable/employmentShiftTable";

import * as branchSettingsParser from '../legacy/parser/branchSettingsParser';

import { store as roleStoreOld } from "./stores/role_store"
import * as ccbiz from "./ccbiz";
import { makeTableDates } from "../table/v1/table";

import viewTypes from "../table/v1/viewTypes";
import { PlanFunctionStore } from "../store/v1/planFunction";
import { PlanValueStore } from "../store/v2/planValue";
import { PlanVariableStore } from "../store/v1/planVariable";
import { initLegacyFunctions } from "../legacy/plan/legacyPlan";

import * as kot from "./kot";
import * as smarthr from "./smarthr";
import { getAndUpdateRolesList, initSlotModalRoleListComponent } from "../slotModal/roleList";
import { cellEditMode } from "../summaryTable/tableEditMode";
import { reactiveSlotLogMap, initSlotLogMap } from "./slotLog";
import CellEditMenuWrapper from "../summaryTable/components/CellEditMenuWrapper.vue";
import { autoAIPresenterInjectKey, autoAIViewModelInjectKey, dateNavViewModelInjectKey, summaryTablePresenterInjectKey } from "../provider/provider";
import { AutoAIPresenter } from "../presenter/autoAI";
import { initFooterDropdownHandlers } from "./summary_footer";
import { computeRoleCountData, SummaryTableApp } from "../app/summaryTable";
import { getAutoAISettings } from "../storage/autoAIStorage";

export { handleFooterBtnClick } from "./summary_footer";

let activeCom = null;
let activeUser;
let isUsingRequestSlots = false;

// Global stores and refs to support render / accept shift data from template
// Should be refactored to table app in the future
let tableDates;
let roleStore;
let meStore;
let branchStore;

// DEPRECATED. A temporary solution to allow template to pass data to app.
// Instead of relying on this ref, add new functionality inside app.
/** @type {SummaryTableApp} */
let globalSummaryTableAppRef;

export function getMeStore() {
  return meStore;
}

export function setMeStore(store) {
  meStore = store;
}

// DEPRECATED. A temporary solution to allow template to pass employment store ref to table edit mode.
// Instead of relying on this function, add new functionality inside app.
export function getEmploymentStore() {
  return globalSummaryTableAppRef.getEmploymentStore();
}

export function getPresenter() {
  return globalSummaryTableAppRef.getPresenter();
}

export const deleteMode = reactive({
  isOn: false,
  selectedSlots: []
});

export function handleInitSlotLogMap(newSlotLogMap) {
  initSlotLogMap(newSlotLogMap);
}

export function mountAutoModal(props, roles, tags, summaryTablePresenter) {
  const app = createApp(AutoModal, {
    roles: roles,
    timePeriodType: props.timePeriodType,
    tags: tags,
    activeDate: props.activeDate,
    meStore,
  });
  app.provide(summaryTablePresenterInjectKey, summaryTablePresenter);
  window[MODAL_ID.AUTO_MODAL] = app.mount(MODAL_ID.AUTO_MODAL)
  $(`${MODAL_ID.AUTO_MODAL}-btn`).on("click", () => {
    window[MODAL_ID.AUTO_MODAL].openModal();
  })
}

export function mountAutoAIModal(props, roles, start, end, tags, meStore, summaryTablePresenter) {
  const app = createApp(AutoAIModal);

  const isDayView = props.timePeriodType === periodTypes.DAY;
  const autoAISettings = getAutoAISettings();
  const viewModel = ref({
    groupId: meStore.getActiveGroupId(),
    branchId: meStore.getActiveBranchId(),
    userId: meStore.getActiveUserId(),
    roles: roles,
    checkedRoles: [],
    tags,
    until: props.urlParams.until,
    timePeriodType: props.timePeriodType,
    activeDate: props.activeDate,
    instructions: "",
    sendSkills: autoAISettings.sendSkills,
    sendODays: autoAISettings.sendODays,
    provider: autoAISettings.provider,
    isVisible: false,
    isLoading: false,
    showRoles: isDayView,
    showCreateEditOptions: !isDayView,
    editExisting: false,
    isDone: false,
    notesJapanese: "",
    reloadOnDone: true,
    dateRange: { start, end },
    filteredRoleIds: props.urlParams.roles,
    promptHistory: [],
    selectedPromptId: "",
  })

  const presenter = new AutoAIPresenter();
  presenter.setViewModel(viewModel.value)

  app.provide(autoAIViewModelInjectKey, readonly(viewModel));
  app.provide(autoAIPresenterInjectKey,  presenter);
  app.provide(summaryTablePresenterInjectKey, summaryTablePresenter);
  window["#auto-ai-modal"] = app.mount("#auto-ai-modal")
}

export function getDateStringsForSlotPassThrough(slot, tz, repeatDate) {
  return getDateStringsForSlot(slot, tz, repeatDate);
}

export function updateSelectedSlotsCount() {
  const text = document.getElementById("delete-slot-count");
  const count = deleteMode.selectedSlots.length;
  return text.innerText = count;
}

export function resetSelectedSlots() {
  deleteMode.selectedSlots = [];
  updateSelectedSlotsCount();
}

//findRoleById will use .find() on the dash base's App.roles data array with optional chaining. Returns a role object or undefined.
export function findRoleById(roleId) {
  return App?.roles?.find(r => r.ID == roleId);
}

//findUserById will use .find() on the dash base's App.userMap object with optional chaining. Returns an object with a subset of fields from a BranchUser or undefined.
export function findUserById(userId) {
  return App?.userMap?.[userId];
}

/**
 * @typedef {Object} SlotModalPayload
 * @property {string} from
 * @property {string} to
 * @property {number|string} comID
 * @property {string} date
 * @property {number} type
 * @property {string} purpose
 * @property {boolean} locked
 * @property {number|string} rest
 * @property {number|string} wage
 * @property {boolean} sendEmail
 * @property {string} help
 * @property {true} isMadeFromTemplate
 * @property {string} memo
 * @property {1 | undefined} [repeat]
 * @property {number | undefined} [extractID]
 * @property {true | undefined} [edited]
 * @property {number | undefined} [userID]
 * @property {number | undefined} [roleID]
 * @property {number | undefined} [patternID]
 * @property {number | undefined} [askStatus]
 * @property {string | undefined} [special]
 * @property {string | undefined} [users]
 * @property {string | undefined} [color]
 * @property {string | undefined} [comment]
 */

/**
 * Constructs a slot payload object from the current slot modal form values.
 *
 * @param {boolean} extract Whether to build the payload for extract mode instead of repeat mode.
 * @returns {SlotModalPayload|null|undefined} The slot payload, `null` when all required fields are empty, or `undefined` when time validation fails.
 */
function constructDataFromSlotModal(extract) {
  $("#slot-modal-from").removeClass("is-error");
  $("#slot-modal-to").removeClass("is-error");
  $("#slot-modal-purpose").removeClass("is-error");

  const fromInput = $("#slot-modal-from").val().trim();
  const toInput = $("#slot-modal-to").val().trim();
  const rawFrom = fromInput.length === 3 ? `0${fromInput}` : fromInput;
  const rawTo = toInput.length === 3 ? `0${toInput}` : toInput;
  const purpose = $("#slot-modal-purpose").val().trim();

  const parsedFrom = ExtractTimeAndMin(rawFrom, true);
  const parsedTo = ExtractTimeAndMin(rawTo, true);

  if (rawFrom !== "" && !parsedFrom.isValid) {
    $("#slot-modal-from").addClass("is-error");
    return;
  }
  if (rawTo !== "" && !parsedTo.isValid) {
    $("#slot-modal-to").addClass("is-error");
    return;
  }

  if (SlotModal.type == 0 && !SlotModal.roleID && !SlotModal.patternID) {
    if (rawFrom === "" && rawTo === "" && purpose === "") {
      $("#slot-modal-from").addClass("is-error");
      $("#slot-modal-to").addClass("is-error");
      $("#slot-modal-purpose").addClass("is-error");
      return null;
    }
  }

  /** @type {SlotModalPayload} */
  const data = {
    "from": parsedFrom.toString(),
    "to": parsedTo.toString(),
    "comID": activeCom.ID,
    "date": SlotModal.slotDate,
    "type": SlotModal.type,
    "purpose": $("#slot-modal-purpose").val(),
    "locked": $("#slot-modal-lock-checkbox").prop("checked"),
    "rest": $("#slot-modal-rest").val(),
    "wage": $("#slot-modal-wage").val(),
    "sendEmail": $("#slot-modal-send-email-checkbox").prop("checked"),
    "help": $("#slot-modal-help").val(),
    "isMadeFromTemplate": true,
    "memo": $("#slot-modal-memo").val(),
  };

  if (!extract) {
    const repeat = $("#slot-modal-repeat-checkbox").prop("checked");
    if (repeat) {
      data["repeat"] = 1;
    }
  } else {
    data["extractID"] = SlotModal.slotID;
  }

  // SlotModal.edited is a boolean flag to signify if a shift leader or owner is performing the slot creation or edit. This includes comments.
  if (SlotModal.edited) {
    data["edited"] = true;
  }

  if (SlotModal.userID) {
    data["userID"] = SlotModal.userID;
  }
  if (SlotModal.roleID) {
    data["roleID"] = SlotModal.roleID;
  }
  if (SlotModal.patternID) {
    data["patternID"] = SlotModal.patternID;
  }
  if (SlotModal.askStatus > 0) {
    data["askStatus"] = SlotModal.askStatus;
  }
  if (SlotModal.data["special"]){
    data["special"] = SlotModal.data["special"];
    addFilteredUsersToData(data);
  }

  const selectedColor = getSelectedColorBox();
  if (selectedColor !== undefined) {
    data["color"] = selectedColor;
  }

  // for Edit
  if (!extract && SlotModal.slot) {
    return data
  }

  // for Create
  data["comment"] = $("#slot-modal-comment").val();
  return data;
}

// addFilteredUsersToData adds a string of visible user ids to post data
// Note: this is copied from slot_crud file
/**
 * @param {SlotModalPayload} data
 */
export function addFilteredUsersToData(data) {
  if (data["special"] != "all"){
    return;
  }
  const visibleUsers = [];
  // For now, go to the DOM to get visible users and their ids. In the future, this will be a prop or data value.
  $('.user-row').each(function(_, element) {
    visibleUsers.push($(element).data("id"));
  })

  data["users"] = visibleUsers.join(",");

}

// Construct data object from selected slot template
function constructDataFromSlotTemplate(dateUnix, userID, special) {
  if (!selectedTemplate) {
    return;
  }
  const slot = SlotMap[selectedTemplate.id];

  if (dashboard.alertStaffIfVacationMaxedOut(slot)) {
    alertModal.alert("月休み希望数を超えています。", false);
    return;
  }

  const date = dateFromSecondsTimestamp(dateUnix);
  const dateString = goDateString(date); // YYYY-MM-DD date string is used for data purposes.

  let from = "", to = "", type, patternID, purpose, rest, locked, color, roleID, memo;

  if (selectedTemplate.type === "pattern") {
    type = 0;
    patternID = selectedTemplate.id;
  } else if (selectedTemplate.type === "slot" && slot) {
    if (!slot.HideFrom) {
      from = slot.FromLabel;
    }
    if (!slot.HideTo) {
      to = slot.ToLabel;
    }
    type = slot.Type;
    purpose = slot.Purpose;
    rest = slot.Rest;
    locked = slot.Locked;
    color = slot.Color;
    roleID = slot.RoleID;
    memo = slot.Memo;
  } else if (selectedTemplate.type === "role") {
    roleID = selectedTemplate.id;
    type = selectedTemplate.slotType;
  } else {
    return;
  }

  const data = {
    "from": from,
    "to": to,
    "comID": activeCom.ID,
    "date": dateString,
    "type": type,
    "purpose": purpose,
    "rest": rest,
    "locked": locked,
    "edited": activeUser.canEdit,
    "userID": userID,
    "color": color,
    "patternID": patternID,
    "roleID": roleID,
    "special": special,
    "isMadeFromTemplate": true,
    "memo": memo,
  };

  addFilteredUsersToData(data);

  return data;
}

// getPutDataEndDateString derives the calendar end date string for a slot put payload,
// accounting for shifts that span past midnight (where "to" is earlier than "from").
function getPutDataEndDateString(data) {
  const startDate = dateFromString(data.date, "utc");
  const endDate = data.to <= data.from ? addDaysToDate(startDate, 1) : startDate;
  return goDateString(endDate);
}

export async function putSlotAfterDrag(slotID, data, oldSlot, event) {
  const presenter = globalSummaryTableAppRef.getPresenter();
  if (presenter.isLockedBySchedule(oldSlot.Date, getSlotToDateString(oldSlot)) || presenter.isLockedBySchedule(data.date, getPutDataEndDateString(data))) {
    presenter.promptUnlock(oldSlot.Date, getSlotToDateString(oldSlot), () => {
      presenter.unlockScheduleIntervalByDate(data.date, getPutDataEndDateString(data));
      revertSlotDOM(event, oldSlot.UserID, oldSlot.Date);
    }, () => {
      revertSlotDOM(event, oldSlot.UserID, oldSlot.Date);
    })

    return;
  }

  try {
    const response = await slotPutRequest(slotID, data);
    if (isUsingRequestSlots) {
      handleDragRequestSlotDOM(response, event, oldSlot);
    }
    const slot = getFirstSlotFromResponse(response);
    addToUndoStack(slot, structuredClone(oldSlot), false, true);
    handleDragSlotSuccess(response);
  }
  catch (err) {
    alertModal.alert(errors.SLOT.UPDATE);
    return;
  }
}

export function handleDragSlotSuccess(response) {
  let slot;
  if (!response.success) {
    alertModal.alert(errors.SLOT.UPDATE, true);
    return
  }
  // update labels if type is 0
  if (!response.addList || response.addList.length == 0) {
    slot = response.slot
    response.addList = [ response.slot ];
  }

  if (response.addList && response.addList.length > 0) {
    for (let i = 0; i < response.addList.length; i++) {
      globalSummaryTableAppRef.handleRawSlotDrag(response.addList[i]);
    }

    // Stats requires special handling for linked slots.
    const isLinkedSlotsDrag = response.addList[0].LinkNext || response.addList[0].LinkPrev;
    if (isLinkedSlotsDrag) {
      handleStatsLinked(response.addList);
    }
  }

  if (response.deleteList) {
    for (let i = 0; i < response.deleteList.length; i++) {
      SlotModal.onDelete(response.deleteList[i]);
    }
  }
}

// DOM manipulation when Requested Slot settings is ON
function handleDragRequestSlotDOM(response, event, oldSlot) {
  // data response changes when Request slot setting is ON,
  // When we drag a slot created by staff, we receive 2 slots data, (response.slot and response.addList)
  // this is to make all these slots are on the same array (addList) in order to render them
  if (response.slot && response.addList.length == 1) {
    response.addList.push(response.slot);
  }
  // Send the dragged slot to its original cell when its a slot created by Staff
  revertSlotDOM(event, oldSlot.UserID, oldSlot.Date);
}

// Moves a dragged slot's DOM node (already relocated by Droppable) back into the
// dropzone for the given user/date.
function revertSlotDOM(event, targetUserID, targetDate) {
  $(`#date-${targetUserID}_${targetDate} .vue-cell-dropzone`).append(event.originalSource);
  $(event.originalSource).removeClass("disabled");
}

// Submit function for creating/editing slot
let isSubmitting = false;
async function summarySlotSubmit(extract) {
  try {
    if (isSubmitting) {
      return;
    }
    if (!extract && $("#slot-submit").is(":hidden")) {
      return;
    }
    $(SLOT_SUBMIT_BUTTON_ID.SUBMIT).addClass("loading");
    isSubmitting = true;

    const data = constructDataFromSlotModal(extract);
    if (!data) {
      return;
    }
    let response;
    if ((!extract || SlotModal?.slot?.RepeatKey) && SlotModal?.slot) {
      if (data.repeat) {
        const s = SlotModal.slot;
        const isStaffSubmitted = (s.CreatedBy === s.UserID) && (s.UserID !== Number(meStore.getActiveUserId()));
        const isRepeatBlocked = s.RequestedSlot || (isUsingRequestSlots && isStaffSubmitted);

        // Prevent repeating a requested slot submitted by staff
        if (isRepeatBlocked) {
          alertModal.alert("希望シフトを設定している場合、スタッフが提出したシフトはリピートシフトにできません。");
          return;
        }
      }

      response = await slotPutRequest(SlotModal.slot.ID, data);
      const slot = getFirstSlotFromResponse(response);
      addToUndoStack(slot, structuredClone(SlotMap[slot.ID]));
      handleUpdateSuccess(response, true);
    } else {
      response = await slotPostRequest(data);
      const slot = getFirstSlotFromResponse(response);
      addToUndoStack(slot);
      handleCreateSuccess(response, data);
    }
  }
  catch (err) {
    alertModal.alert(errors.SLOT.CREATE, true);
  } finally {
    isSubmitting = false;
    $(SLOT_SUBMIT_BUTTON_ID.SUBMIT).removeClass("loading");
  }

  SlotModal.close();
}

function handleSlotSubmit() {
  return summarySlotSubmit(false);
}

function handleSlotExtract() {
  // Bandaid fix when submitting repeated slot, until we find better solution,
  // We ask users if they want to edit and remove this slot from the repeated slots and create a new one instead.
  if (!confirm("このリピートシフトは解除され新規のシフトに変更されますが、よろしいですか？")) {
    return;
  }
  return summarySlotSubmit(true);
}

function handleSlotCommentExtract() {
  // can add comment as usual for new repeat slots since there's a real slot now
  if (SlotModal.slot?.RepeatKey) {
    SlotModal.sendComment();
    return;
  }

  if (!confirm("コメント追加により、このリピートシフトは解除され新規のシフトに変更されますが、よろしいですか？")) {
    return;
  }
  return summarySlotSubmit(true);
}

// Submit function for deleting slot
function summarySlotDelete() {
  if (!SlotModal.slotID) {
    return;
  }
  if (SlotModal.slot.Repeat || SlotModal.slot.RepeatKey) {
    showDashModal(true, DELETE_SLOT_PARAM_STR.DELETE_REPEAT);
    return;
  }
  handleSummarySlotDelete();
  return;
}

async function handleSummarySlotDelete() {
  $(SLOT_SUBMIT_BUTTON_ID.DELETE).addClass("loading");
  try {
    const response = await slotDeleteRequest(SlotModal.slotID);
    // Since we currently use Modal to delete slots, we grab the ID from the SlotModal object
    // We currently do not support undo when doing bulk delete, because we also don't have bulk create for slots.
    addToUndoStack(structuredClone(SlotMap[SlotModal.slotID]), null, true);
    handleDeleteSuccess(response);
  }
  catch (err) {
    return alertModal.alert(errors.SLOT.DELETE);
  }
  finally {
    SlotModal.close();
  }
}

async function addSummarySlotTemplate(dateUnix, userID, special) {
  const data = constructDataFromSlotTemplate(dateUnix, userID, special);

  try {
    const response = await slotPostRequest(data);
    const slot = getFirstSlotFromResponse(response);
    addToUndoStack(slot);
    return handleTemplateCreateSuccess(response);
  }
  catch (err) {
    return alertModal.alert(errors.SLOT.CREATE);
  }
}

function undoActionCallback(undoActionType, responses, isDrag, slots = []) {
  switch (undoActionType) {
    case ACTIONS_TYPE.CREATE:
      responses.forEach(handleCreateSuccess);
      return;
    case ACTIONS_TYPE.DELETE:
    case ACTIONS_TYPE.BULK_DELETE:
      responses.forEach(handleDeleteSuccess);
      return;
    case ACTIONS_TYPE.UPDATE:
      responses.forEach(resp => {
        if (isDrag) {
          handleDragSlotSuccess(resp);
        } else {
          handleUpdateSuccess(resp, true);
        }
      });
      return;
    case ACTIONS_TYPE.BULK_CREATE:
      responses.forEach(handleTemplateCreateSuccess);
      return;
    case ACTIONS_TYPE.BULK_CUT:
      const splitIndex = slots.length;
      responses.slice(0, splitIndex).forEach(handleDeleteSuccess);
      responses.slice(splitIndex).forEach(handleTemplateCreateSuccess);
      return;
  }
}

export async function undoHandler() {
  const lastAction = getLastUndoStack();

  if (!lastAction || !meStore) {
    return;
  }

  enableUndoLoading();
  const { undoActionType, slots, newSlots, isDrag } = lastAction;

  try {
    const responses = await undoActionRequest(undoActionType, slots, newSlots, meStore.getActiveUserId(), meStore.getActiveBranchId());
    undoActionCallback(undoActionType, responses, isDrag, slots);
    removeLastActionFromUndoStack();
    removeDeletedSlotInStack(undoActionType, slots);
  } catch (err) {
    alertModal.alert("unable to undo:", err);
  } finally {
    disableUndoLoading();
  }
}

// Override handleAddButtonClick function from dashboard_base file
export function handleSummaryAddButtonClick(dateUnix, userID, slotID, formValues = {}) {

  if (!selectedTemplate) {
    const presenter = globalSummaryTableAppRef.getPresenter();
    const date = goDateString(new Date(dateUnix * 1000));
    if (presenter && presenter.isLockedBySchedule(date)) {
      presenter.promptUnlock(date, undefined, () => {
        openSlotModal(dateUnix, userID, slotID, formValues);
      });
      return;
    }

    openSlotModal(dateUnix, userID, slotID, formValues);
    return;
  }

  addSummarySlotTemplate(dateUnix, userID, formValues.special);
  return;
}

async function summaryDeleteRepeatSlot() {
  const choiceValue = document.querySelector('.delete-repeat-choice:checked')?.value;
  if (choiceValue) {
    const params = `?repeat=1&type=${DELETE_REPEAT_INPUT_VALUE[choiceValue]}&date=${SlotModal.slotDate}`
    $(SLOT_SUBMIT_BUTTON_ID.DELETE_REPEAT).addClass("loading");

    try {
      const response = await slotDeleteRequest(SlotModal.slotID, params)
      handleDeleteSuccess(response);
    }
    catch (err) {
      return alertModal.alert(errors.SLOT.DELETE);
    }
    finally {
      SlotModal.close();
    }
  }
}

// Helper function to get first slot (in case of split) from response, specifically or currently used for undo feature
function getFirstSlotFromResponse(response) {
  let slot = response.slot;
  if (response.addList && response.addList.length) {
    slot = response.addList[0];
  }

  return slot;
}

// For interfacing with template
export function handleRawSlotChange(rawSlot) {
  if (!rawSlot || rawSlot.LinkNext || rawSlot.LinkPrev) {
    return;
  }

  globalSummaryTableAppRef.handleRawSlotChange(rawSlot);
}

// Interface for template
export function handleStatsLinked(rawSlots) {
  if (!rawSlots && !rawSlots.length) {
    return;
  }

  globalSummaryTableAppRef.handleStatsLinked(rawSlots);
}

// handle help select input change on slot modal
export function handleHelpBranchChange(branchId) {
  let selectedBranchId = branchId
  // if no branchId value, we fetch the active branch instead
  if (!branchId) {
    selectedBranchId = activeCom.ID;
  }
  getAndUpdateRolesList(selectedBranchId);
  return;
}

export function setRoleIdToSlotModal(roleId) {
  SlotModal.setRole(roleId);
  return;
}

// For interfacing with template
export function handleRawSlotsBulkSelectedDelete(slotIds) {
  globalSummaryTableAppRef.handleRawSlotsBulkSelectedDelete(slotIds);
}

// For interfacing with template
export function handleRawSlotsBulkDelete(slotIds) {
  globalSummaryTableAppRef.handleRawSlotsBulkDelete(slotIds);
}

// For interfacing with template
export function handleSlotDelete(rawSlot) {
  if (!rawSlot) {
    return;
  }

  // A delete a.k.a. "extract" of a repeat instance requires passing the date of the extracted repeat instance.
  const dateUnix = rawSlot.Repeat ? SlotModal.data?.dateUnix : undefined;
  globalSummaryTableAppRef.handleRawSlotDelete(rawSlot, dateUnix);
}

async function ccbizSync(startDate, endDate) {
  if (!activeCom?.hasCCBizMate) {
    alertModal.alert("The current company has no CC·BizMate id!", false)
    return;
  }

  ccbiz.sync(startDate, endDate);
}

async function initTable(props) {
  const branch = newBranchFromRaw(props.pipelineActiveCompany, props.pipelineActiveBranchSettings);
  branchStore = newBranchStore(branch);

  meStore = newMeStore(props.activeUserID, props.canEdit, branch.id, props.activeGroupID);

  roleStore = newRoleStoreFromRaw(props.roles || [], props.orRolesMap);

  // Hotfix: 1 is month, 0 is week
  const defaultSetting = props?.pipelineActiveBranchSettings?.DefaultView == 0 ? viewTypes.WEEK : viewTypes.MONTH;
  const dateStr = props.urlParams.date;
  const endDateStr = props.urlParams.until ?? "";
  const listValue = props.urlParams.list;
  const viewType = calcViewType(defaultSetting, endDateStr !== "", listValue);
  // To work "properly" with oplus time, hardcode time zone to JST
  // Eventually, this will be a user setting and/or guess
  const localTimezone = "Asia/Tokyo";
  const activeBranch = branchStore.byId(meStore.activeBranchId);
  const startDate = calcTableStartDate(dateStr, localTimezone, viewType, branch.getMonthStart(), branch.getWeekStart());
  const endDate = calcTableEndDate(endDateStr, localTimezone, startDate, branch.getMonthStart(), viewType);

  tableDates = makeTableDates(startDate, endDate, periodTypes.DAY, localTimezone);

  const rolesToDisplayCount = [];
  if (props?.rootRoles) {
    props.rootRoles.forEach(role => {
      if (!role.ShowStaffCount) {
        return;
      }

      const r = roleStore.byId(role.ID);
      if (!r) {
        return;
      }

      rolesToDisplayCount.push(r)
    })
  }

  const summaryTableApp = new SummaryTableApp(props.useSectionWage, props.canViewSpotWork);
  const settings = branch.getSettings();
  const showMemo = settings.memoSummary && (props?.canEdit ?? false);
  summaryTableApp.setShowMemo(showMemo);
  summaryTableApp.setRoleCountData(computeRoleCountData(props.roleCountData));
  summaryTableApp.setHasAutoPerm(props.hasAutoPerm ?? false);
  summaryTableApp.setViewType(viewType);
  summaryTableApp.setBranchDefaultMaxMonthly(props.branchDefaultMaxMonth ?? 0);
  summaryTableApp.setBranchDefaultMonthlyVacationLimit(props.branchDefaultMonthlyVacationLimit ?? 0);
  summaryTableApp.setCanEdit(props.canEdit);
  summaryTableApp.setTemplates(props.templates ?? []);
  summaryTableApp.setTableDates(tableDates);
  summaryTableApp.setScheduleIntervals(tableDates, settings)
  const b = {
    id: branch.id,
    name: branch.getBranchName(),
    groupId: props.pipelineActiveCompany?.GroupID ?? 0,
    ownerIds: [],
    employeeIds: props.pipelineActiveCompany.employeeIDs,
    address: props.pipelineActiveCompany.Address,
    groupName: props.pipelineActiveCompany.GroupName,
  }
  summaryTableApp.setBranch(b);
  summaryTableApp.provideBranchSettings(settings);
  summaryTableApp.provideCellEditMode(cellEditMode);
  summaryTableApp.provideDeleteMode(deleteMode);
  summaryTableApp.provideMeStore(meStore);
  summaryTableApp.provideRoleStore(roleStore);
  summaryTableApp.provideSlotLogMap(reactiveSlotLogMap);
  summaryTableApp.provideUseShiftBorders(props.useShiftBorders);
  const lockStatsColumns = !props?.hasProSubscription ?? true;
  const showUserAlertBadges = (viewType === viewTypes.MONTH || viewType === viewTypes.WEEK) && props?.canEdit
  summaryTableApp.initPresentationStats(rolesToDisplayCount, settings, lockStatsColumns, showUserAlertBadges);
  globalSummaryTableAppRef = summaryTableApp;
  await summaryTableApp.init();
  summaryTableApp.renderDeferrableDOMManipulations(props);

  if (props.canEdit) { // TODO: use meStore to determine perm level
    await initFunctionRows(props.legacyPlans, props.pipelineActiveBranchSettings.PlanEquationValue, activeBranch, tableDates);
  }

  return summaryTableApp.getPresenter();
}

// initFunctionRows will initialize the plan function rows for the current view.
// Also used on dws.
export async function initFunctionRows(legacyPlans = [], planEquationValue, activeBranch, tableDates) {
  const planVarStore = new PlanVariableStore()
  const valueStore = new PlanValueStore();
  const functionStore = new PlanFunctionStore();
  const initParams = {
    legacyPlans,
    branch: activeBranch,
    planEquationValue,
  }

  initLegacyFunctions(functionStore, valueStore, planVarStore, initParams);

  await initPlanFunctions(tableDates, activeBranch, functionStore, valueStore);

  renderFunctionRows(functionStore, valueStore, tableDates, activeBranch);
}

function renderFunctionRows(functionStore, valueStore, tableDates, activeBranch) {
  const toCompute = functionStore.query({branchId: activeBranch.getId()});
  const dateToFuncIdToValue = makeComputedValuesMap(tableDates, toCompute, functionStore, valueStore);
  const tableDatesMap = {};
  tableDates.forEach(td => tableDatesMap[td.index()] = td);
  Object.keys(dateToFuncIdToValue).forEach(d => {
    const td = tableDatesMap[d];
    if (!td) {
      return;
    }

    Object.keys(dateToFuncIdToValue[d]).forEach(pfId => {
      // Hacky render for now
      const v = dateToFuncIdToValue[d][pfId];
      const oplusTime = toOplusTime(td.getDate());
      const id = `#pf-${pfId}-${timestampSecsFromDate(oplusTime)}`;
      $(id).text(roundTwoDecimals(v));
    })
  })
}

export function mountCellEditMenuApp(viewType, isUsingRequestSlots, presenter) {
  const app = createApp(CellEditMenuWrapper, {
    viewType,
    isUsingRequestSlots,
  });
  if (presenter) {
    app.provide(summaryTablePresenterInjectKey, presenter);
  }
  app.mount("#cell-edit-menu-app");
}

// Scrolls to today's date in the table
export function scrollToToday() {
  var todayElm = `#date-${GetToday()}`;
  var todayElement = document.querySelector(todayElm);

  if (todayElement) {
    setTimeout(() => {
      todayElement.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
    }, 400);
  }
}

export function setCalendarModal() {
  const modal = $("#calendar-modal");
  if (modal.length) {
    $("#calendar-btn-dropdown").click(() =>  modal.show());
  }
}

export function initUserLaborBadges(users, summaryStats, meStore, employmentStore, viewType, branchDefaultMaxMonth, shifts, cloneLaborMap, branchDefaultMonthlyVacationLimit) {
  if (!users || !users.length) {
    return;
  }

  const isMonthView = viewType === viewTypes.MONTH;
  const userIds = Array.from(new Set(users.map(u => u.ID)));
  const vacationCountMap = isMonthView
    ? computeRequestedVacationByUser(userIds, summaryStats.dates, shifts)
    : new Map();

  const laborMinutesMap = new Map();
  const employments = employmentStore.query({branchId: meStore.getActiveBranchId()});

  for (const e of employments) {
    const row = summaryStats.getRowStats(e.index()).getData();
    if (!row) {
      continue;
    }
    const userId = Number(e.getUserId());
    const cloneLaborHours = cloneLaborMap.get(userId) ?? 0;
    laborMinutesMap.set(userId, (row.laborHours + cloneLaborHours) * 60);
  }

  for (const u of users) {
    const row = document.getElementById(String(u.ID));
    const bu = u.BranchUser;
    const laborMinutes = laborMinutesMap.get(u.ID);

    if (!row || !bu || laborMinutes === undefined) {
      continue;
    }

    if (isMonthView) {
      const limits = {
        minMonthLaborMinutes: bu.MinMonthLaborMinutes || 0,
        maxMonthLaborMinutes: bu.MaxMonthLaborMinutes || branchDefaultMaxMonth || 0,
        monthlyVacationLimit: bu.MonthlyVacationLimit || branchDefaultMonthlyVacationLimit || 0,
      };
      const flags = computeMonthlyLaborFlags(limits, laborMinutes, vacationCountMap.get(u.ID) || 0);
      if (flags.overMaxVacation) {
        row.querySelector('.over-max-vacation')?.classList.remove('d-none');
      }
      if (flags.overMaxMonth) {
        row.querySelector('.over-max-month')?.classList.remove('d-none');
      } else if (flags.underMinMonth) {
        row.querySelector('.under-min-month')?.classList.remove('d-none');
      }
    } else {
      const flags = computeLaborFlags(
        bu.MinWeekLaborMinutes || 0,
        bu.MaxWeekLaborMinutes || 0,
        laborMinutes,
      );
      if (flags.overMax)  {
        row.querySelector('.over-max-week')?.classList.remove('d-none');
      } else if (flags.underMin) {
        row.querySelector('.under-min-week')?.classList.remove('d-none');
      }
    }
  }
}

export function openAlertModal(errText) {
  return alertModal.alert(errText)
}

export function openConfirmModal(text, callback, cancelCallback) {
  return alertModal.confirm(text, callback, cancelCallback);
}

export function toggleUnlockSlotBtn(slotList) {
  const btn = document.getElementById("unlock-slot-btn");
  if (!btn) {
    return;
  }

  const hasLockedSlot = slotList.some(s => {
    if (s.Repeat) {
      return Boolean(s.RepeatLocked?.length)
    }
    return s.Locked
  })

  if (hasLockedSlot) {
    btn.classList.remove("d-none");
  } else {
    btn.classList.add("d-none");
  }
}

export function mountSummaryDateNavView(props, start, end, tags, settings) {
  const app = createApp(SummaryDateNavView);
  const viewModel = ref({
    activeCompanyID: props.pipelineActiveCompany.ID,
    activeUserID: props.activeUserID,
    startDate: start,
    endDate: end,
    timePeriodType: props.timePeriodType,
    currentPage: props.page,
    showDailyButton: true,
    tags: tags || [],
    roles: props.roles,
    hasPro: props.hasProSubscription,
    hasTag: props.hasTagPerm,
    canEdit: props.canEdit,
    isDWS: false,
    hidePeriodSelector: props.hidePeriodSelector ?? false,
    workerOnly: isQueryParamTrue("workerOnly"),
    lockedOnly: isQueryParamTrue("lockedOnly"),
    scheduleEnabled: settings?.scheduleEnabled ?? false,
    scheduleCustomEnabled: settings?.scheduleCustomEnabled ?? false,
    scheduleLength: settings?.scheduleLength ?? 0,
    scheduleStartDate: settings?.scheduleStartDate,
  })

  app.provide(dateNavViewModelInjectKey, readonly(viewModel));
  app.use(i18n);
  app.mount("#summary-date-nav-view");
}

export async function initPage(props) {
  // Legacy. Can remove when confirmed not in use.
  roleStoreOld.init(props.roles, props.orRolesMap);
  const {startDate: startOplusTime, endDate: endOplusTime} = createStartAndEndDatesFromArray(props.dates)
  activeUser = transformUser({
    canEdit: props.canEdit,
  });
  activeCom = transformCompany(props.pipelineActiveCompany);
  gBranchSettings = branchSettingsParser.parseFromRaw(props.pipelineActiveBranchSettings);

  isUsingRequestSlots = props.isUsingRequestSlots;
  if (isUsingRequestSlots) {
    disableSaveUndo();
  }

  // Table init
  const presenter = await initTable(props);

  mountCellEditMenuApp(props.timePeriodType, isUsingRequestSlots, presenter);
  initSlotModalRoleListComponent(activeCom.ID)
  // as of 2023-12-06 DashURL function is in dashboard_base.html line 4602
  getPageSlotURL(DashURL("slot"))
  initFooterDropdownHandlers();

  setStickyRoleRows();
  initMemoColumnSticky();

  // Override submit/delete button for modal and template functions to isolate summary page's (monthly/weekly) slot CRUD
  // In the future, it should also apply to other pages that needs the same CRUD functions, (shift_base, summary_dws)
  // Note: dashboard_base.html binds its own "click" handlers for these same IDs (moved off inline
  // onclick="" attributes for CSP compliance), so .off("click") is required here to detach that
  // handler before rebinding — otherwise both fire and the base handler throws (it references
  // slot_crud, which isn't loaded on the summary page).
  $(SLOT_SUBMIT_BUTTON_ID.SUBMIT).off("click").on("click", () => handleSlotSubmit());
  $(SLOT_SUBMIT_BUTTON_ID.EXTRACT).off("click").on("click", () => handleSlotExtract());
  $(SLOT_SUBMIT_BUTTON_ID.DELETE).off("click").on("click", () => summarySlotDelete());
  $(SLOT_SUBMIT_BUTTON_ID.DELETE_REPEAT).off("click").on("click", () => summaryDeleteRepeatSlot());
  $(SLOT_SUBMIT_BUTTON_ID.SUBMIT_COMMENT_EXTRACT).off("click").on("click", () => handleSlotCommentExtract());

  // CCbiz
  // sync button
  $(`#${ccbiz.CCBIZ_ELEMENT_IDS.SYNC_BUTTON}`).on('click', () => ccbizSync(startOplusTime, endOplusTime));

  $(`#${kot.BULK_SYNC_BUTTON}`).on('click', () => kot.bulkSync(startOplusTime, endOplusTime));
  $(`#${smarthr.SHIFT_SYNC_BUTTON}`).on('click', () => smarthr.syncShifts(props.activeUserID, meStore.getActiveBranchId(), startOplusTime, endOplusTime));

}


// postLocked will request the BE lock or unlock all slots for a given date range and optional set of filters, returning slots and repeat slots affected.
// Expected response:
// {
//   slots: LockSlotView[],
//   repeatSlots: LockRepeatSlotView[],
// }

// LockSlotView {
// 	id number
// 	isLocked boolean
// 	isKOTSynced boolean
// }

// LockRepeatSlotView {
// 	id           number
// 	repeatLocked string[] (oplus time timestamp strings)
// }

let isLockLoading = false;
export async function postLocked(isLocking, slotMap) {
  if (isLockLoading) {
    return;
  }

  const btn = document.getElementById("footer-lock-button");
  btn?.classList.add('loading');
  isLockLoading = true;
  // Include all search query params from summary page
  const params = new URLSearchParams(window.location.search);
  const locked = isLocking ? '1' : '0';
  params.set('locked', locked)

  const url = `${window.location.pathname}/lock_slots?${params.toString()}`;
  try {
    const rawRes = await fetch(url, {
      method: "POST",
      body: JSON.stringify({
        excludedDates: globalSummaryTableAppRef.getPresenter().getScheduleLockedDates()
      })
    })

    if (rawRes.status !== 200) {
      throw new Error('failed')
    }

    const json = await rawRes.json();

    const newSlots = [];

    for (const slot of json.slots) {
      if (!slotMap[slot.id]) {
        continue;
      }
      const copy = structuredClone(slotMap[slot.id]);
      copy.Locked = slot.isLocked;
      copy.KOTSynced = slot.isKOTSynced;
      newSlots.push(copy);
    }

    for (const repeatSlot of json.repeatSlots) {
      const prev = slotMap[repeatSlot.id];
      if (!prev) {
        continue;
      }

      const copy = structuredClone(prev);
      copy.RepeatLocked = repeatSlot.repeatLocked;
      copy.Locked = true;
      newSlots.push(copy);
    }

    globalSummaryTableAppRef.handleRawSlotsLocked(newSlots);

  } catch {
    let msg = "確定できませんでした。";
    if (!isLocking) {
      msg = "確定解除できませんでした。"
    }
    openAlertModal(msg);
  } finally {
    isLockLoading = false;
    btn?.classList.remove('loading');
  }

}

// Temporary solution.
// Allows SummaryTableApp to interact with global App.userMap
export function setGlobalAppUserMap(userMap) {
  App.userMap = userMap;
}

// Temporary solution.
// Allow SummaryTable app to mutate global SlotMap var in dashboard_base.html
export function setSlotMap(slotMap) {
  if (!SlotMap) {
    return;
  }

  Object.assign(SlotMap, slotMap);
}

// Allows SummaryTable app to mutate droppable global var in summary.html.
export function addElToDroppable(el) {
  if (!droppable) {
    return;
  }
  droppable.addContainer(el);
}

// Temporary solution.
// Allows SummaryTable app to mutate droppable global var in summary.html.
export function removeElFromDroppable(el) {
  if (!droppable) {
    return;
  }
  droppable.removeContainer(el);
}

// openPopup allows SummaryTable app to interact with the global popup element
// Copy of behavior found in synchronous event listener in dashboard_base.html
export function openPopup(text, htmlEl) {
  if (!text) {
    return;
  }
  $("#name-table-popup").text(text);
  // the tooltip position needs to remember that the left most column of the table is sticky
  const jEl = $(htmlEl);
  const offset = jEl.offset();
  offset.top += jEl.height() / 4;
  offset.left += jEl.outerWidth() / 3;
  $("#name-table-popup").css(offset);
  setTimeout(function(){
    $("#name-table-popup").show();
  }, 100);
}

// due to weird global variable interaction
export function importAlertModal() {
  return alertModal;
}

const LEFTCOL_WIDTH_KEY = 'summary_leftcol_width';
const MEMOCOL_WIDTH_KEY = 'summary_memo_col_width';

function initNonDailyColResize() {
  const table = document.querySelector('#summary-table');

  if (!table)
    return;

  const columns = [
    {
      storageKey: LEFTCOL_WIDTH_KEY,
      cssProperty: '--summary-name-col-width',
      headerSelector: '.sticky th:first-child',
      cellSelector: 'th:first-child, td:first-child',
      resizingClass: 'col-resizing',
      minWidth: 100,
    },
    ...(table.classList.contains('has-memo-column') ? [{
      storageKey: MEMOCOL_WIDTH_KEY,
      cssProperty: '--summary-memo-col-width',
      headerSelector: '.sticky th.memo-text',
      cellSelector: 'th.memo-text, td.memo-text',
      resizingClass: 'memo-col-resizing',
      minWidth: 80,
    }] : []),
  ];

  for (const column of columns) {
    const saved = parseFloat(localStorage.getItem(column.storageKey));
    if (saved) {
      setColumnWidth(column, saved);
    }
  }
  syncSummaryMemoStickyOffset();

  function tryStartNonDailyResize(e, clientX, clientY, hitZone, showIndicator) {
    const handle = e.target.closest('.col-resize-handle');
    const firstCell = e.target.closest('th:first-child, td:first-child');
    const memoCell = table.classList.contains('has-memo-column') ? e.target.closest('th.memo-text, td.memo-text') : null;
    const targetCell = handle?.closest('th, td') || firstCell || memoCell;
    if (!targetCell) {
      return;
    }
    if (!handle) {
      const rect = targetCell.getBoundingClientRect();
      if (clientX < rect.right - hitZone) return;
    }

    const column = columns.find(({ cellSelector }) => targetCell.matches(cellSelector));
    if (!column) {
      return;
    }

    e.preventDefault();
    const startX = clientX;
    const startWidth = targetCell.getBoundingClientRect().width;
    const startRight = targetCell.getBoundingClientRect().right;

    let indicator = null;
    if (showIndicator) {
      indicator = document.createElement('div');
      indicator.style.cssText = `position:fixed;pointer-events:none;z-index:9999;top:${clientY - 8}px;left:${startRight - 8}px;`;
      indicator.innerHTML = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="2" cy="2" r="2" fill="#5F6B71"/><circle cx="8" cy="2" r="2" fill="#5F6B71"/><circle cx="14" cy="2" r="2" fill="#5F6B71"/><circle cx="2" cy="8" r="2" fill="#5F6B71"/><circle cx="8" cy="8" r="2" fill="#5F6B71"/><circle cx="14" cy="8" r="2" fill="#5F6B71"/><circle cx="2" cy="14" r="2" fill="#5F6B71"/><circle cx="8" cy="14" r="2" fill="#5F6B71"/><circle cx="14" cy="14" r="2" fill="#5F6B71"/></svg>`;
      document.body.appendChild(indicator);
    }

    table.classList.add(column.resizingClass);

    let lastWidth = startWidth;
    function setWidth(x) {
      lastWidth = Math.max(column.minWidth, startWidth + (x - startX));
      setColumnWidth(column, lastWidth);
      if (indicator) indicator.style.left = `${startRight + (lastWidth - startWidth) - 8}px`;
    }
    function onMouseMove(e) { setWidth(e.clientX); }
    function onTouchMove(e) { e.preventDefault(); setWidth(e.touches[0].clientX); }
    function cleanup() {
      localStorage.setItem(column.storageKey, lastWidth);
      table.classList.remove(column.resizingClass);
      if (indicator)
        indicator.remove();
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', cleanup);
      document.removeEventListener('touchmove', onTouchMove);
      document.removeEventListener('touchend', cleanup);
    }

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', cleanup);
    document.addEventListener('touchmove', onTouchMove, { passive: false });
    document.addEventListener('touchend', cleanup);
  }

  table.addEventListener('mousedown', function(e) { tryStartNonDailyResize(e, e.clientX, e.clientY, 32, false); });
  table.addEventListener('touchstart', function(e) { tryStartNonDailyResize(e, e.touches[0].clientX, e.touches[0].clientY, 32, true); }, { passive: false });
}

function setColumnWidth(column, width) {
  document.documentElement.style.setProperty(column.cssProperty, `${width}px`);
  const th = document.querySelector(column.headerSelector);
  if (th) {
    th.style.width = `${width}px`;
    th.style.minWidth = `${width}px`;
    th.style.maxWidth = `${width}px`;
  }
  if (column.cssProperty === '--summary-name-col-width') {
    syncSummaryMemoStickyOffset();
  }
}

function syncSummaryMemoStickyOffset() {
  const firstHeader = document.querySelector('#summary-table .sticky th:first-child');
  if (!firstHeader) {
    return;
  }
  const renderedWidth = Math.ceil(firstHeader.getBoundingClientRect().width);
  if (renderedWidth) {
    document.documentElement.style.setProperty('--summary-name-col-sticky-offset', `${renderedWidth}px`);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initNonDailyColResize);
} else {
  initNonDailyColResize();
}

function observeLastStickyRoleRow(scrollContainer, lastStickyRow) {
  const sentinel = document.createElement('tr');
  sentinel.className = 'sticky-sentinel';
  lastStickyRow.parentNode?.insertBefore(sentinel, lastStickyRow);

  const stickyTop = parseFloat(lastStickyRow.style.top || '0');

  // Observe when the sentinel leaves the visible area of the scroll container. When it's no longer visible, the sticky row reached its "sticky" position
  const stickyRoleRowsObserver = new IntersectionObserver(
    ([entry]) => {
      // Add thicker bottom border for last sticky row
      lastStickyRow.classList.toggle('last-sticky-role', entry.intersectionRatio === 0);
    },
    {
      root: scrollContainer,
      threshold: [0],
      rootMargin: `-${stickyTop}px 0px 0px 0px`,
    },
  );

  stickyRoleRowsObserver.observe(sentinel);
}

// If role.IsCountFixed setting is true, set the role count row to be sticky
function setStickyRoleRows() {
  const scrollContainer = document.querySelector('.table-wrapper');
  if (!scrollContainer) {
    return;
  }

  const stickyRows = [...document.querySelectorAll('tr.sticky-role')];
  if (!stickyRows.length) {
    return;
  }

  const maxStickyHeight = scrollContainer.clientHeight * 0.7;
  const headerHeight = 60; // px, matches header height
  // The schedule row (if shown) is sticky too, directly below the header (see #summary-table
  // tr.summary-schedule-row in summary.html); stack role rows below it instead of overlapping it.
  const scheduleRow = document.getElementById('summary-schedule-row');
  const scheduleRowHeight = scheduleRow?.offsetHeight || 0;

  // Assign increasing `top` so sticky role rows stack. Once max height is exceeded, later rows keep the same offset and overlap the previous sticky row.
  const heights = stickyRows.map((row) => row.offsetHeight);
  let top = headerHeight + scheduleRowHeight;
  stickyRows.forEach((row, i) => {
    row.style.top = `${top}px`;
    if (top + heights[i] <= maxStickyHeight) {
      top += heights[i];
    }
  });

  observeLastStickyRoleRow(scrollContainer, stickyRows[stickyRows.length - 1]);
}

export function getSlotFromSlotMap(id) {
  return SlotMap[id];
}

const MEMO_FIXED_KEY = 'summary_memo_fixed';

function setMemoColumnSticky(table, isSticky, toggleButton) {
  table.classList.toggle("memo-column-sticky", isSticky);
  toggleButton?.classList.toggle("active", isSticky);
}

function handleMemoColumnStickyToggle(event) {
  toggleMemoColumnSticky(event.currentTarget);
}

function initMemoColumnSticky() {
  const table = document.querySelector("#summary-table");
  const toggleButton = document.querySelector('.memo-sticky-toggle');
  if (!table || !toggleButton) {
    return;
  }

  setMemoColumnSticky(table, localStorage.getItem(MEMO_FIXED_KEY) === 'true', toggleButton);
  toggleButton.addEventListener('click', handleMemoColumnStickyToggle);
}

export function toggleMemoColumnSticky(toggleButton) {
  const table = document.querySelector("#summary-table");
  if (!table) {
    return;
  }

  const isSticky = !table.classList.contains("memo-column-sticky");
  setMemoColumnSticky(table, isSticky, toggleButton);
  localStorage.setItem(MEMO_FIXED_KEY, isSticky);
}
